module.exports = __webpack_public_path__ + "static/img/fotile.36c7f475.png";